import { AppRouteRecordRaw } from '../types';

const Body = () => import('@/components/body.vue');
const SecuritySettings = () => import('@/pages/users/security/SecuritySettings.vue');

export const securityRoutes: AppRouteRecordRaw[] = [
  {
    path: '/profile',
    component: Body,
    meta: {
      breadcrumb: 'Profile',
    },
    children: [
      {
        path: 'security',
        name: 'securitySettings',
        component: SecuritySettings,
        meta: {
          title: 'Security Settings | ryd Portal',
          breadcrumb: 'Security Settings',
        },
      },
    ],
  },
];
